define('drops/contentRegion/contentRegion',[
    'jquery',
    'underscore',
    'lq/style',
    'drops/action/action',
    'lq/layouting',
    'lq/responsive',
    'lq/validatorGateway',
    'lq/drop',
    'when',
    'lq/highlighter'
], function ($, _, Style, Action, layouting, responsive, validatorGateway, Drop, when, highlighter) {
    'use strict';

    var defaults = {
        data: {
            sharedParameters: [],
            eventsToCatch: []
        }
    };

    var ContentRegion = function (options) {
        Drop.call(this, $('<div/>'), defaults, options);
        Style.renderStyles(this);

        this.$wrapper = $('<div class="licquid-action-wrapper" />')
            .css({
                width: '100%',
                height: '100%'
            })
            .appendTo(this.$element);
        this.$view = $('<div class="licquid-action-view" />')
            .appendTo(this.$wrapper);

        this.bindingsOfThisAction = undefined;
        this.bindingsOfChildAction = undefined;
    };

    Drop.extend(ContentRegion, Drop);

    ContentRegion.typeName = 'ContentRegion';

    ContentRegion.sharedSystemParameters = [
        'CurrentActionId',
        'CurrentUser',
        'CurrentLanguage',
        'CurrentLanguageISOCode',
        'CurrentLayoutName',
        'IsProcessAction',
        'IsSelectionAction',
        'IsPageAction',
        'RuntimeMode'
    ];

    ContentRegion.prototype.preRender = function () {
        this.piping.visibility.apply(this);
        this.applyPosition();

        if (!validatorGateway.isEnabled()) {
            var self = this;
            this.gatewayCallback = function () {
                if (!self.action) return;
                self.informValidator(self.action, false);
            };
            validatorGateway.whenEnabled(this.gatewayCallback);
        }
    };

    ContentRegion.prototype.copyParameterToChild = function (sharedParameter, newValue, parameterType) {
        if (!this.action) return;
        this.copyParameterToPiping(this.action.piping, sharedParameter, newValue, parameterType);
    };

    ContentRegion.prototype.copyParameterToParent = function (sharedParameter, newValue, parameterType) {
        this.copyParameterToPiping(this.piping, sharedParameter, newValue, parameterType);
    };

    ContentRegion.prototype.copyParameterToPiping = function (targetPiping, sharedParameter, newValue, parameterType) {
        if (this.updating) return;

        this.updating = true;

        if (parameterType === 'local')
            targetPiping.parameters.locals.setValue(sharedParameter, newValue);

        if (parameterType === 'global')
            targetPiping.parameters.globals.setValue(sharedParameter, newValue);

        if (parameterType === 'system')
            targetPiping.parameters.systems.setValue(sharedParameter, newValue);

        this.updating = false;
    };

    ContentRegion.prototype.setContent = function (contentArray, locals, insertionPoint) {
        var self = this;

        // the page holding the content region may have been unloaded before its content was set
        if (!this.piping) return when.resolve();

        if (!this.bindingsOfThisAction) {
            this.bindingsOfThisAction = _.map(this.data.sharedParameters, function (sharedParameter) {
                return self.piping.parameters.subscribeForUpdates(sharedParameter, self.copyParameterToChild.bind(self, sharedParameter));
            });
        }

        if (insertionPoint && insertionPoint !== this.rootDrop.data.id) {
            return this.action.setContent(contentArray, locals, insertionPoint);
        } else {
            var actionData = contentArray[0].action;

            return this.runContentLoadingEvent(actionData)
                .then(function() {
                    // the parent action may have been unloaded while ContentLoading was being handled
                    if (!self.piping) return;

                    var systemParameters = contentArray[0].systemParameters;
                    var localParameters = contentArray.length > 1 ? {} : locals;

                    var action = new Action(actionData.view, self.piping.application.options);
                    action.loadData(actionData);
                    action.piping = self.piping.createChildPiping(actionData, action, localParameters, systemParameters, self.$wrapper, self.$view, false);

                    if(self.data.eventsToCatch) {
                        for(var anEvent of self.data.eventsToCatch){
                            action.piping.eventing.subscribe(anEvent, self.receiveEvent.bind(self, anEvent));
                        }
                    }

                    action.globals = _.clone(self.piping.parameters.globals.getAll());
                    action.locals = _.clone(locals);

                    var layout = responsive.getCurrentLayout(action);
                    layouting.applyLayout(self.$view, layout);
                    action.applyLayout(layout, false);

                    return action.piping.viewTransitionManager.scheduleViewTransition(
                        function () {
                            // WHY: the parent action may have been unloaded while this waited for its turn, rendering now
                            // would leave drops behind that nobody cleans up (e.g. date pickers and modals under the body)
                            if (!self.piping) {
                                action.piping.cleanUp();
                                action.unsubscribeEventHandlersRecursive();
                                return;
                            }

                            var promise = self.startActionRender(action, actionData);
                            self.postActionRender(action, contentArray, locals);
                            return promise;
                        })
                        .then(function () {
                            return action.startEventing();
                        })
                        .then(function() {
                            if (contentArray.length > 1) {
                                return action.setContent(contentArray.slice(1), locals);
                            }
                        })
                        .then(function() {
                            if(!self.isEventEnabled('contentLoaded'))
                                return;

                            var deferred = when.defer();

                            var eventData = self.getEventDataFor('contentLoaded');
                            self.triggerEvent(
                                eventData.raisedEventName,
                                actionData.id,
                                undefined,
                                undefined,
                                false,
                                undefined,
                                function() {
                                    deferred.resolve();
                                },
                                'contentLoaded');

                            return deferred.promise;
                        }); 
                })
        }
    };

    ContentRegion.prototype.runContentLoadingEvent = function (actionData) {
        if(!this.isEventEnabled('contentLoading'))
            return when.resolve();
        
        var deferred = when.defer();

        var eventData = this.getEventDataFor('contentLoading');

        this.triggerEvent(
            eventData.raisedEventName,
            actionData.id,
            undefined,
            undefined,
            false,
            undefined,
            function() {
                deferred.resolve();
            },
            'contentLoading');

        return deferred.promise;        
    };

    ContentRegion.prototype.startActionRender = function (action, actionData) {
        return action.createAndRenderDrops($());
    };

    ContentRegion.prototype.postActionRender = function (action, contentArray, locals) {
        if (validatorGateway.isEnabled()) {
            var canReload = contentArray.length === 1; // only the inner-most action can be reloaded
            this.informValidator(action, canReload);
        }

        var self = this;
        _.each(this.data.sharedParameters, function (sharedParameter) {
            if (action.piping.parameters.locals.parameterExists(sharedParameter))
                self.piping.parameters.locals.setValue(sharedParameter, action.piping.parameters.locals.getValue(sharedParameter));
            if (action.piping.parameters.globals.parameterExists(sharedParameter))
                self.piping.parameters.globals.setValue(sharedParameter, action.piping.parameters.globals.getValue(sharedParameter));
        });

        var bindingsOfChildAction = _.map(this.data.sharedParameters, function (sharedParameter) {
            return action.piping.parameters.subscribeForUpdates(sharedParameter, self.copyParameterToParent.bind(self, sharedParameter));
        });

        // probably not the most efficient way to share system parameters
        _.forEach(ContentRegion.sharedSystemParameters, function(parameter) {
            bindingsOfChildAction
                .push(action.piping.parameters.subscribeForSystemUpdates(parameter, self.copyParameterToParent.bind(self, parameter), true));
        });

        if (this.$element.css('position') === 'relative') {
            if (action.data.makeItGrow && this.data.growingDrop) {
                this.$element.css('height', 'auto');
            } else if (isNaN(action.data.top) || isNaN(action.data.height)) {
                this.$element.css('height', action.data.size.y + 'px');
            } else {
                this.$element.css('height', '20px');
            }
        }

        this.cleanupCurrentAction();

        this.action = action;
        this.bindingsOfChildAction = bindingsOfChildAction;

        this.piping.busyIndicator.forceHide();
    };

    ContentRegion.prototype.receiveMessage = function (message) {
        switch (message.type) {

            case 'RELOAD_ACTION_INSTANCE':
                this.piping.runtime.actionLoader.load(this.action.data.id, this.action.globals, this.action.locals, { ignoreHistory: true }, []);
                break;

            case 'HIGHLIGHT_ACTION_INSTANCE':
                highlighter.highlight(this.$wrapper);
                break;

        }
    };

    ContentRegion.prototype.informValidator = function (action, canReload) {
        validatorGateway.registerListener(action.instanceId, this.receiveMessage.bind(this));

        validatorGateway.publishEvent({
            type: 'ACTION_INSTANCE_LOADED',
            action: action,
            parentInstanceId: this.rootDrop.instanceId,
            canReload: canReload
        });
    };

    ContentRegion.prototype.cleanupCurrentAction = function () {
        if (!this.action) return;

        if (validatorGateway.isEnabled()) {
            validatorGateway.publishEvent({
                type: 'ACTION_INSTANCE_UNLOADING',
                action: this.action
            });
        }

        this.action.piping.cleanUp();
        this.action.unsubscribeEventHandlersRecursive();

        if (validatorGateway.isEnabled()) {
            validatorGateway.unregisterListener(this.action.instanceId);
        }

        this.disposeBindings(this.bindingsOfChildAction);

        this.action = null;
    };

    ContentRegion.prototype.disposeBindings = function (bindings) {
        _.each(bindings, function (binding) {
            binding.dispose();
        });
    };

    ContentRegion.prototype.unsubscribeEventHandlers = function () {
        this.cleanupCurrentAction();

        if (this.gatewayCallback) {
            validatorGateway.removeCallback(this.gatewayCallback);
        }

        this.disposeBindings(this.bindingsOfThisAction);
    };

    ContentRegion.prototype.receiveEvent = function (eventName, eventSource, args, callback, parentEventAction) {
        this.piping.eventing.publish(
            this.data.id + '.' + eventName,
            eventSource,
            args,
            callback,
            parentEventAction
            );
    };

    return ContentRegion;
});
